/**
 * TIDAL: barra de filtros móvil (recuento, chips de filtros activos, contador en el botón),
 * grupos plegados por defecto en móvil y "Restablecer todo" en el pie del panel.
 */
(function () {
  var MOBILE = window.matchMedia('(max-width: 1023.98px)');

  function form() { return document.getElementById('facets'); }

  function activeLinks() {
    var f = form();
    return f ? Array.prototype.slice.call(f.querySelectorAll('.facets__active-filters .active-filter')) : [];
  }

  function render() {
    var f = form();
    if (!f) return;
    var countEl = f.querySelector('.js-tidal-results-count');
    var count = countEl ? countEl.getAttribute('data-count') : null;
    var links = activeLinks();

    var countOut = document.querySelector('.js-tidal-count');
    var bar = document.getElementById('tidal-mbar');
    if (countOut && count !== null && bar) {
      var tpl = (count === '1' ? bar.getAttribute('data-label-one') : bar.getAttribute('data-label-other')) || '__N__';
      countOut.textContent = tpl.replace('__N__', count);
    }

    var chips = document.querySelector('.js-tidal-chips');
    if (chips) {
      chips.innerHTML = '';
      links.forEach(function (a, i) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'tidal-chip';
        chip.setAttribute('data-index', String(i));
        chip.innerHTML = '<span>' + a.textContent.trim() + '</span><span class="tidal-chip__x" aria-hidden="true">\u00d7</span>';
        chips.appendChild(chip);
      });
      if (links.length > 1) {
        var reset = document.createElement('button');
        reset.type = 'button';
        reset.className = 'tidal-chip tidal-chip--reset';
        reset.setAttribute('data-reset', 'true');
        reset.textContent = (document.getElementById('tidal-mbar') || {}).getAttribute ? (document.getElementById('tidal-mbar').getAttribute('data-clear-all') || 'Borrar todo') : 'Borrar todo';
        chips.appendChild(reset);
      }
    }

    var badge = document.querySelector('.js-tidal-badge');
    if (badge) { badge.textContent = String(links.length); badge.hidden = links.length === 0; }

    var resetAll = document.querySelector('.js-tidal-reset');
    if (resetAll) resetAll.hidden = links.length === 0;
  }

  function collapseOnMobile() {
    if (!MOBILE.matches) return;
    var f = form();
    if (!f) return;
    f.querySelectorAll('details-disclosure > details[open]').forEach(function (d) {
      // Mantener abierto el grupo de "filtros aplicados"; plegar el resto
      if (d.closest('.facets__active-filters')) return;
      d.removeAttribute('open');
    });
  }

  document.addEventListener('click', function (evt) {
    var chip = evt.target.closest && evt.target.closest('.tidal-chip, .js-tidal-reset');
    if (!chip) return;
    var f = form();
    if (!f) return;
    if (chip.hasAttribute('data-reset') || chip.classList.contains('js-tidal-reset')) {
      var clear = f.querySelector('.js-clear-all');
      if (clear) clear.click();
      return;
    }
    var link = activeLinks()[Number(chip.getAttribute('data-index'))];
    if (link) link.click();
  });

  document.addEventListener('on:facet-filters:updated', function () { render(); });

  // Barra fija bajo la cabecera cuando la barra original sale de la vista (solo móvil).
  // Centinela de altura cero (nunca cambia de tamaño) + listener de scroll: sin bucles.
  function stickyBar() {
    var tb = document.querySelector('.products-toolbar');
    if (!tb || !MOBILE.matches) return;
    var sentinel = document.createElement('div');
    sentinel.className = 'tidal-toolbar-sentinel';
    var ph = document.createElement('div');
    ph.className = 'tidal-toolbar-placeholder';
    tb.parentNode.insertBefore(sentinel, tb);
    tb.parentNode.insertBefore(ph, tb);

    var stuck = false;
    function headerBottom() {
      var hb = 0;
      document.querySelectorAll('.shopify-section-group-header-group').forEach(function (el) {
        var cs = getComputedStyle(el);
        if (cs.position === 'sticky' || cs.position === 'fixed') hb = Math.max(hb, el.getBoundingClientRect().bottom);
      });
      return Math.max(0, Math.round(hb));
    }
    function update() {
      var hb = headerBottom();
      var shouldStick = sentinel.getBoundingClientRect().top < hb;
      if (shouldStick && !stuck) {
        // reservar el hueco (alto + margen inferior) antes de sacar la barra del flujo
        var mb = parseFloat(getComputedStyle(tb).marginBottom) || 0;
        ph.style.height = (tb.offsetHeight + mb) + 'px';
        tb.style.top = hb + 'px';
        tb.classList.add('is-stuck');
        stuck = true;
      } else if (!shouldStick && stuck) {
        tb.classList.remove('is-stuck');
        tb.style.top = '';
        ph.style.height = '0px';
        stuck = false;
      } else if (stuck) {
        tb.style.top = hb + 'px';
      }
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  }

  function init() { collapseOnMobile(); render(); stickyBar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
